import Cart from 'cart-store';
// 复制 标签
class CopyText extends HTMLElement {
  constructor() {
    super();
    const { copyBtn, copyText } = this.dataset;
    if (copyBtn && copyText) {
      $(this)
        .find(copyBtn)
        .on('click', () => {
          copyToClipboard(copyText, '已複製');
        });
    }
  }
}
// 折扣标签
class SaveLabels extends HTMLElement {
  constructor() {
    super();
    const elParent = $(this).closest('product-single');
    $(elParent).on('change', 'product-form input[name=id]', e => {
      $(this).find('.variant').css('visibility', 'hidden');
      $(this).find(`.variant[data-sku="${e.target.value}"]`).css('visibility', 'visible');
    });
  }
}

// 锚点标签
class MainBadge extends HTMLElement {
  constructor() {
    super();
    this.switch_effect = this.dataset.switch_effect;
    if (this.switch_effect == 'true') {
      this.changeShow($(this).find('.badge-item').first().data('id'));
    }
    this.init();
  }
  init() {
    const _this = this;
    $(this)
      .find('.badge-item')
      .on('click', function (e) {
        const id = $(this).data('id');
        if (!id) return;
        if (_this.switch_effect == 'true') {
          _this.changeShow(id);
        } else {
          if (id && $(id).length) {
            $('html, body').animate(
              {
                scrollTop: $(id).offset().top - $('header-container').height() - 30,
              },
              800,
            );
          }
        }
      });
  }
  changeShow(id) {
    Array.from($(this).find('.badge-item')).forEach((item, index) => {
      const current_id = $(item).data('id');
      if ((current_id = id)) {
        $(current_id).show();
      } else {
        $(current_id).hide();
      }
    });
  }
}
class DynamicButton extends HTMLElement{#t;constructor(){super(),this.#t=null}connectedCallback(){if(this.children.length>1){const t=this.children[this.children.length-1],e={attributes:!1,childList:!0,subtree:!0};new MutationObserver(((t,e)=>{if(t.some((t=>"childList"===t.type))){const t=this.querySelector(".dynamic-button__placeholder");t&&t.remove(),e.disconnect()}})).observe(t,e)}}disconnectedCallback(){this.#t&&this.#t.disconnect()}}

class QuantityInput extends HTMLElement{#t;#e;#i;#s;constructor(){super(),this.#t=this.add.bind(this),this.#i=this.subtract.bind(this),this.#s=this.validate.bind(this),this.#e=QuantityInput.#n.bind(this)}connectedCallback(){this.input=this.querySelector('input[type="number"]'),this.minus=this.querySelector("button[minus]"),this.plus=this.querySelector("button[plus]"),this.min=Number(this.input.getAttribute("min")||0),this.max=Number(this.input.getAttribute("max")||1/0),this.step=Number(this.input.getAttribute("step")||1),setTimeout((()=>{this.minus.addEventListener("click",this.#i),this.plus.addEventListener("click",this.#t),this.input.addEventListener("change",this.#s),this.input.addEventListener("select",this.#e),this.input.addEventListener("click",this.#e)}))}disconnectedCallback(){this.minus.removeEventListener("click",this.#i),this.plus.removeEventListener("click",this.#t),this.input.removeEventListener("change",this.#s),this.input.removeEventListener("select",this.#e),this.input.removeEventListener("click",this.#e)}subtract(){const t=Number(this.input.value);t>this.min&&(this.input.value=t-Math.min(this.step,t-this.min),this.dispatchEvent(new CustomEvent("update",{detail:{value:this.input.value}})))}add(){const t=Number(this.input.value);t<this.max&&(this.input.value=t+Math.min(this.step,this.max-t),this.dispatchEvent(new CustomEvent("update",{detail:{value:this.input.value}})))}validate(t){const{value:e}=t.target;(!/^[0-9]+$/.test(e)||Number(e)<this.min)&&(this.input.value=this.min),Number(e)>this.max&&(this.input.value=this.max),this.dispatchEvent(new CustomEvent("update",{detail:{value:this.input.value}}))}set value(t){this.input.value=Number(t)}get value(){return Number(this.input.value)}static#n(t){t.target.select()}};

const STATES=["IDLE","DOING","DONE"];class StagedAction extends HTMLElement{#s;#t=1500;constructor(){super(),this.#s=this.querySelector("staged-action-tick")}setState(s=STATES[0]){return new Promise(((t,i)=>{if(STATES.includes(s)||i(new Error("Invalid state")),s===STATES[0]&&(this.classList.remove("is-done"),this.classList.remove("is-doing"),t("Idle")),s===STATES[1]&&(this.classList.remove("is-done"),this.classList.add("is-doing"),t("Doing")),s===STATES[2]){this.classList.remove("is-doing"),this.classList.add("is-done");this.#s.getAnimations().length>0?this.#s.addEventListener("animationend",(()=>{this.classList.remove("is-done"),t("Done")})):setTimeout((()=>{this.classList.remove("is-done"),t("Done")}),this.#t)}}))}};

class HeaderContainer extends HTMLElement{#t;#e=!1;#s;#r;#i=0;#l=!1;constructor(){super(),this.#t=this.#o.bind(this)}connectedCallback(){if(this.#l=Boolean(this.dataset.sticky),this.#l){this.#s=new IntersectionObserver((([t])=>document.body.classList.toggle("header-stuck",!t.isIntersecting)),{threshold:[1]}),this.#s.observe(this);const t=this.querySelector(".js-header");if(t?.classList.contains("js-header-scroll")){const e=t.getBoundingClientRect().height+50;window.addEventListener("scroll",this.#t),this.#r=setInterval((()=>{this.#e&&(this.#c(e),this.#o(!1))}),250)}}}disconnectedCallback(){this.#l&&(this.#s&&this.#s.disconnect(),this.#r&&clearInterval(this.#r),window.removeEventListener("scroll",this.#t))}#o(t=!0){this.#e=t}#c(t,e=5){const s=window.scrollY;Math.abs(this.#i-s)<=e||(s>this.#i&&s>t?(document.body.classList.remove("header-down"),document.body.classList.add("header-up")):(document.body.classList.remove("header-up"),document.body.classList.add("header-down")),this.#i=s)}};

class DeferredMedia extends HTMLElement{constructor(){super();const e=this.querySelector("media-poster");e&&e.addEventListener("click",this.loadContent.bind(this),{once:!0})}loadContent(e=!0){if(!this.getAttribute("loaded")){const t=document.createElement("div");t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),this.setAttribute("loaded",!0);const d=this.appendChild(t.querySelector("video, model-viewer, iframe"));e&&d.focus()}}};

class CartLink extends HTMLElement {
    constructor() {
      super(), (this.itemsCount = this.querySelector('items-count'));
    }
    connectedCallback() {
      this.unsubscribe = Cart.subscribe(t => {
        this.itemsCount.innerHTML = t.cart.item_count;
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }

  customElements.define('quantity-input', QuantityInput);
$(() => {  
  customElements.define('copy-text', CopyText);
  customElements.define('save-labels', SaveLabels);
  customElements.define('main-badge', MainBadge);
  customElements.define("dynamic-button",DynamicButton);
  customElements.define("staged-action",StagedAction);
  customElements.define("header-container",HeaderContainer)
  customElements.define("deferred-media",DeferredMedia)
  customElements.define('cart-link', CartLink);
});
